export enum SearchParams {
  SEARCH_TERM = 'searchTerm',
  LIMIT = 'limit',
  ORDER_BY = 'orderBy',
  PAGE = 'page',
  PRICE = 'price',
  BRANDS = 'filteredBrands',
}

export enum OrderByType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum MyPurchaseParams {
  LIMIT = 'limit',
  ORDER_BY = 'orderBy',
  PAGE = 'page',
}
